import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwesnnk2bk: FaireProductEntity = {
  token: "p_bwesnnk2bk",
  type: "product",
  name: "Love Botanical Bath Ritual Kit",
  brandToken: "b_hmppz48z2y",
  brandName: "8 Days Botanicals",
  imageUrl:
    "https://cdn.faire.com/fastly/5a6cfe9d8fbf92c7ae02914d6ba038ccbcf919558f854720e38414964d2e488f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eea973a3fe814a47cc328ce3317b49662921e5b29a6d2a3f76538eeadbaf4ed5.png",
    "https://cdn.faire.com/fastly/9c4c9e98622c83e9259f02bdeaf96029b4c7b5398ce71c6dbd4adce83e200a47.png",
    "https://cdn.faire.com/fastly/b0ffacc51d6242d594c92dbc16516279d4d87ee0a79e5f60db7131d7cb21f268.png",
    "https://cdn.faire.com/fastly/2f5103b5dd8124ba1c5361e40fe487ece77aa62e12926db1938ed3328d0faf00.png",
  ],
  priceDollars: 32.5,
  description:
    "Find Love, 8 Days a Week\n\nGive the gift of Love with our Botanical Bath Ritual Kit. Featuring our Love Body Butter, Ritual Spray, Botanical Bath Shot, and a beeswax candle, this kit is the perfect way to show you care.\n\nLike a warm embrace, this kit inspires a moment of self-care and indulgence, whether that be with your special someone, or simply a moment with yourself.\n\nWrapped in a lovely gift box with a handmade, dried flower bouquet from Dewdrop Farm, this gift box looks as special as it feels.\n\nKey Botanicals: Rose, sandalwood, geranium\n\n• Our luscious whipped Body Butter features organic jojoba oil infused with fresh rose petals directly from our farm in Sonoma County\n• Aromatherapeutic, certified organic essential oils and precious botanical absolutes instantly uplift your mood with our easy to use Ritual Sprays\n• Loaded with fresh flowers and herbs from our farm, our Botanical Bath Shots restore moisture, enhance your mood\n• Locally sourced beeswax candle for relaxation",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:02.851Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
